import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=736ae670&scoped=true"
import script from "./rolePermission.vue?vue&type=script&lang=js"
export * from "./rolePermission.vue?vue&type=script&lang=js"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=736ae670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ae670",
  null
  
)

export default component.exports